<template>
  <div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllFacturesAPayerSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-3">
            <b-input :placeholder="$t('listePaiementFactureAchat.actions.search')"
                     type="search"
                     icon="magnify"
                     v-model="criteresRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
          <div class='column is-narrow'>
            <date-picker :dates='criteresRecherche.dates'
                         :triggerSearchEveryTime="false"
                         :updateEndDateAtChangeStartDate="false"
                         @recherche="recherche"/>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permsEcheancierContrat.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <cumul-by-type-paiement :liste-paiement="this.facturesAPayer" :surFacture="true"
          @updateFilters="updateFiltersForCumul" :cumulByTypeActionAchat="cumulByTypeActionAchat"
          :criteresRecherche="criteresRecherche" v-if="cumulByTypeActionAchat">
    </cumul-by-type-paiement>
    <div class="level-right">
      <div class="lien mgb-20px has-text-right is-cursor-pointer"
           @click="displayOrMasquerFactureAnt()">
        {{ displayFacturesAnt
        ? $t('listePaiementFactureAchat.masquerEchAnt')
        : $t('listePaiementFactureAchat.displayEchAnt', {total: totalFacturesBeforeNow >= 0
            ? totalFacturesBeforeNow : $t('general.enCoursCalcul') }) }}
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering && mountedLoadingEnd"
      class="overflow-x-auto">
      <template slot='afterTable'>
        <table-items-in-view
          @input="$refs[referenceTable].setLimit($event)"
          :perPage="resultPerPage"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"
                    :value="props.row">
        </b-checkbox>
      </div>
      <div slot="codeFacture" slot-scope="props">
        <router-link-blank
          :to="{ name: linkName,
                params: { id: props.row.factureId } }"
          :message="props.row.referenceFournisseur
          ? props.row.referenceFournisseur : props.row.code"></router-link-blank>
      </div>
      <div slot="dateEcheance" slot-scope="props">
        {{ props.row.dateEcheance | formatDate }}
      </div>
      <div slot="referencePaiement" slot-scope="props" class="has-text-editInTable">
        {{ props.row.referencePaiement }}
      </div>
      <div slot="commentaire" slot-scope="props" class="has-text-editInTable ellipsis">
        {{ props.row.commentaire }}
      </div>
      <div slot="bonAPayer" slot-scope="props" class="has-text-editInTable">
        {{ props.row.bonAPayer ? $t('listePaiementFactureAchat.yes')
        : $t('listePaiementFactureAchat.no') }}
      </div>
      <div slot="blocageReglement" slot-scope="props">
        {{ props.row.blocageReglement ?
        $t('listePaiementFactureAchat.yes') : $t('listePaiementFactureAchat.no') }}
      </div>
      <div slot="montantEcheanceTtc" slot-scope="props" class="has-text-right">
        {{ props.row.resteALettrer | formatDevise }}
      </div>
      <div slot="modeReglement" slot-scope="props">
        {{ getModeReglement(props.row.modeReglementId) }}
      </div>
      <div slot="validateur" slot-scope="props" class="has-text-editInTable">
        {{ findLibelleValidateur(props.row.validateur) }}
      </div>
      <div slot="statusRapprochement" slot-scope="props" class="has-text-centered">
        <b-icon icon="circle"
                :type="getColorStatusRapprochement(props.row.statusRapprochement)"></b-icon>
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <div @click="checkPermissions(permsEcheancierContrat.maj) ?
          editFactureAPayer([props.row]) : showPopUp()"
             class="is-cursor-pointer">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{'text-access-no-permission' :
                  !checkPermissions(permsEcheancierContrat.maj)}">
          </b-icon>
        </div>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-liste-paiement-sur-facture ref="filtreListePaiementSurFacture"
                                           @toggleFiltre="changeValueShowFiltreAndLockMenu()"
                                           :critere-recherche="criteresRecherche"
                                           :moduleDcf="moduleDcf"
                                           @recherche="makeRechercheFilter"/>
      </div>
    </transition>
    <b-modal v-model="popUpEditFacturesAPayer"
             has-modal-card>
      <pop-up-edit-echeances-a-payer :echeancesAPayer="factureAPayerAModifier"
                                     :surFacture="true"
                                     @updateOk="updateEcheances">
      </pop-up-edit-echeances-a-payer>
    </b-modal>
    <b-modal v-model="popUpCreationLotPaiement"
             has-modal-card>
      <creation-lot-paiement :echeances="factureAPayerAModifier"
                             :surFacture="true"
                             @refresh="closeAndSearch"></creation-lot-paiement>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import selecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import datePicker from '@/components/general/datePicker';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import popUpEditEcheancesAPayer from '@/components/baux/echeancesAPayer/p_editEcheancesAPayer';
import creationLotPaiement from '@/components/baux/echeancesAPayer/p_creationLotPaiement';
import { NO_PER_PAGE_VALUE, SORT_ICON, TEXTS } from '@/configuration/clientTableConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import {
  SET_DATES_FACTURES_SAVE,
  SET_DISPLAY_FACTURES_ANT,
} from '@/store/modules/baux/paiementSurFacture-mutation-type';
import snackBarSuccess from '@/services/general/snackbar/snackBarSuccess';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import {
  ACTION_EDIT,
  ACTION_LOT_PAIEMENT_CREATION,
  RESULTS_PER_PAGE_ECHEANCES,
  LISTE_COLOR_STATUS_RAPPROCHEMENT,
} from '@/configuration/baux/echeancesAPayer/echeancesAPayerConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { ECHEANCIER_CONTRAT } from '@/configuration/baux/permissionsBauxConf';
import filtreListePaiementSurFacture from '@/components/baux/echeancesAPayer/filtreListePaiementSurFacture';
import cumulByTypePaiement from '@/components/baux/paiement/cumulByTypePaiement';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_PAIEMENT_SUR_PAIEMENT } from '@/configuration/general/referenceTableConf';
import { MODULE_TLPE, MODULE_ACHAT } from '@/configuration/devisConf';

const PaiementSurFacture = createNamespacedHelpers('paiementSurFacture');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    moduleDcf: {
      type: String,
      required: true,
    },
    referenceTable: {
      type: String,
      required: false,
      default: REFERENCE_TABLE_PAIEMENT_SUR_PAIEMENT,
    },
  },
  data() {
    return {
      loadingComponent: null,
      unsubscribeValue: null,
      showFiltre: false,
      permsEcheancierContrat: ECHEANCIER_CONTRAT,
      factureAPayerAModifier: [],
      popUpEditFacturesAPayer: false,
      popUpCreationLotPaiement: false,
      actions: [
        { action: ACTION_EDIT, translation: 'listePaiementFactureAchat.actions.edit' },
        {
          action: ACTION_LOT_PAIEMENT_CREATION,
          translation: 'listePaiementFactureAchat.actions.creationLotPaiement',
        },
      ],
      resultPerPage: RESULTS_PER_PAGE_ECHEANCES,
      startArrayRendering: false,
      mountedLoadingEnd: false,
    };
  },
  components: {
    selecteurAction,
    TableItemsInView,
    datePicker,
    popUpEditEcheancesAPayer,
    creationLotPaiement,
    routerLinkBlank,
    cumulByTypePaiement,
    filtreListePaiementSurFacture,
    exportExcelButton,
    parametrageTable,
  },
  methods: {
    ...PaiementSurFacture.mapActions({
      loadFactureAPayer: 'loadFactureAPayer',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...PaiementSurFacture.mapMutations({
      setDisplayFacturesAnt: SET_DISPLAY_FACTURES_ANT,
      setDatesFacturesSave: SET_DATES_FACTURES_SAVE,
    }),
    getColorStatusRapprochement(status) {
      const statusFind = LISTE_COLOR_STATUS_RAPPROCHEMENT.find((statusRapprochment) => {
        return statusRapprochment.code === status;
      });
      return statusFind ? statusFind.color : '';
    },
    updateFiltersForCumul(params) {
      this.criteresRecherche.bonAPayer = params.bap;
      this.criteresRecherche.modesReglementsIds = this.parametre(PARAMETRES_KEYS.modeReglement)
        .filter((modeReglement) => {
          return modeReglement.actionAchat === params.actionAchat;
        })
        .map((modeReglement) => {
          return modeReglement.id;
        });
      this.recherche();
    },
    updateEcheances(donneesUpdates) {
      this.factureAPayerAModifier.forEach((echeance) => {
        echeance.commentaire = donneesUpdates.updateCommentaire
          ? donneesUpdates.commentaire : echeance.commentaire;
        echeance.bonAPayer = donneesUpdates.updateBonAPayer
          ? donneesUpdates.bonAPayer : echeance.bonAPayer;
        echeance.referencePaiement = donneesUpdates.updateReferencePaiement
          ? donneesUpdates.referencePaiement : echeance.referencePaiement;
        echeance.validateur = donneesUpdates.updateValidateur
          ? donneesUpdates.validateur : echeance.validateur;
      });
      this.popUpEditFacturesAPayer = false;
      this.deselectAll();
      this.successUpdateEcheances();
    },
    handleAction(action) {
      switch (action) {
        case ACTION_EDIT:
          this.editFactureAPayer(this.getAllFacturesAPayerSelected());
          break;
        case ACTION_LOT_PAIEMENT_CREATION:
          this.launchPopUpCreationLotPaiement(this.getAllFacturesAPayerSelected());
          break;
        default:
          break;
      }
    },
    displayOrMasquerFactureAnt() {
      this.setDisplayFacturesAnt(!this.displayFacturesAnt);
      if (this.displayFacturesAnt) {
        this.setDatesFacturesSave(cloneDeep(this.criteresRecherche.dates));
        this.criteresRecherche.dates.dateDebut = null;
        this.criteresRecherche.dates.dateFin = new Date();
      } else this.criteresRecherche.dates = cloneDeep(this.datesFacturesSave);
      this.recherche();
    },
    successUpdateEcheances() {
      snackBarSuccess(
        this.$i18n.t('listePaiementFactureAchat.messages.successEdit'),
        this.$i18n.t('listePaiementFactureAchat.actions.reload'),
        () => {
          this.recherche();
        },
      );
    },
    closeAndSearch() {
      this.popUpCreationLotPaiement = false;
      this.recherche();
    },
    launchPopUpCreationLotPaiement(echeances) {
      this.popUpCreationLotPaiement = true;
      this.factureAPayerAModifier = echeances;
    },
    editFactureAPayer(factures) {
      this.factureAPayerAModifier = factures;
      this.popUpEditFacturesAPayer = true;
    },
    findLibelleValidateur(validateurIds) {
      let libelle = '';
      if (!validateurIds) return null;
      validateurIds.forEach((id) => {
        const user = this.parametre(PARAMETRES_KEYS.utilisateur)
          .find((utilisateur) => { return utilisateur.id === id; });
        if (user) libelle += nomPrenomGetter(user) + ', ';
      });
      return libelle.substring(0, libelle.length - 2);
    },
    getModeReglement(id) {
      const modeReglementFind = this.parametre(PARAMETRES_KEYS.modeReglement)
        .find((modeReglement) => {
          return modeReglement.id === id;
        });
      return modeReglementFind ? modeReglementFind.libelle : '';
    },
    getAllFacturesAPayerSelected() {
      return this.facturesAPayer.filter((el) => {
        return el.selected;
      });
    },
    deselectAll() {
      this.facturesAPayer.forEach((el) => {
        el.selected = false;
      });
    },
    selectAll() {
      const select = !this.allFacturesAPayerSelected;
      this.facturesAPayer.forEach((el) => {
        el.selected = select;
      });
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListePaiementSurFacture.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListePaiementSurFacture.initializeFiltre();
      this.$refs.filtreListePaiementSurFacture.viderCritere();
      this.$refs.filtreListePaiementSurFacture.appliquerCritere();
      this.showFiltre = false;
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPageAndCheckChangement() {
      if (this.criteresRecherche.agencesIds.length === 0) return;
      const agencesIds = [];
      this.criteresRecherche.agencesIds.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesIds.push(id);
      });
      this.criteresRecherche.agencesIds = agencesIds;
      this.$refs[this.referenceTable].setPage(1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...PaiementSurFacture.mapGetters({
      criteresRecherche: 'critereRecherche',
      cumulByTypeActionAchat: 'cumulByTypeActionAchat',
      facturesAPayer: 'items',
      totalCount: 'total',
      totalFacturesBeforeNow: 'totalFacturesBeforeNow',
      displayFacturesAnt: 'displayFacturesAnt',
      datesFacturesSave: 'datesFacturesSave',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    allFacturesAPayerSelected() {
      return this.getAllFacturesAPayerSelected().length === this.facturesAPayer.length;
    },
    iconSelectTotal() {
      if (this.allFacturesAPayerSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    linkName() {
      switch (this.moduleDcf) {
        case MODULE_TLPE:
          return 'c.gabed.titre_recette';
        case MODULE_ACHAT:
          return 'c.achat.factures';
        default:
          return 'c.baux.facture_achat';
      }
    },
    codeFacture() {
      switch (this.moduleDcf) {
        case MODULE_TLPE:
          return this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.titreDeRecette');
        case MODULE_ACHAT:
          return this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.facturesAchat');
        default:
          return this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.factures');
      }
    },
    nomCommercial() {
      switch (this.moduleDcf) {
        case MODULE_TLPE:
          return this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.collectivite');
        case MODULE_ACHAT:
          return this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.fournisseur');
        default:
          return this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.bailleur');
      }
    },
    nombreCritere() {
      let nombreCritere = 0;
      if (this.criteresRecherche.modesReglementsIds.length > 0) nombreCritere += 1;
      if (this.criteresRecherche.agencesIds.length > 0) nombreCritere += 1;
      if (this.criteresRecherche.validateurs.length > 0) nombreCritere += 1;
      if (this.criteresRecherche.nomBailleur) nombreCritere += 1;
      if (this.criteresRecherche.montant) nombreCritere += 1;
      if (this.criteresRecherche.blocageReglement !== null) nombreCritere += 1;
      if (this.criteresRecherche.commentaire) nombreCritere += 1;
      if (this.criteresRecherche.referencePaiement) nombreCritere += 1;
      if (this.criteresRecherche.bonAPayer) nombreCritere += 1;
      if (this.criteresRecherche.themeFacture) nombreCritere += 1;
      if (this.criteresRecherche.codeAndReferenceFacture) nombreCritere += 1;
      if (this.criteresRecherche.codeDossierFacture) nombreCritere += 1;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    columns() {
      return ['selected', 'codeFacture', 'theme', 'codeDossier', 'dateEcheance', 'nomCommercial', 'montantEcheanceTtc', 'referencePaiement', 'bonAPayer', 'commentaire', 'validateur', 'blocageReglement', 'motifBlocage', 'modeReglement', 'statusRapprochement', 'edit'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          codeFacture: this.codeFacture,
          theme: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.libelle'),
          codeDossier: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.codeDossier'),
          dateEcheance: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.dateEcheance'),
          nomCommercial: this.nomCommercial,
          montantEcheanceTtc: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.montant'),
          referencePaiement: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.refPaiement'),
          bonAPayer: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.bonAPayer'),
          commentaire: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.commentaire'),
          validateur: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.validateur'),
          blocageReglement: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.blocageReglement'),
          motifBlocage: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.motifBlocage'),
          modeReglement: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.modeReglement'),
          statusRapprochement: this.$i18n.t('listePaiementFactureAchat.tabPaiementSurFacture.statusRapprochement'),
          edit: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          data.query.moduleDcf = this.moduleDcf;
          if (this.criteresRecherche.agencesIds.length === 0) {
            data.query.agencesIds = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          return this.loadFactureAPayer(data);
        }),
        columnsClasses: {
          commentaire: 'colonneCommentaire',
          dateEcheance: 'colonneWidth130px',
          edit: 'colonneSelected',
        },
        responseAdapter: (() => {
          return {
            data: this.facturesAPayer,
            count: this.totalCount,
          };
        }),
        sortable: ['codeFacture', 'theme', 'codeDossier', 'montantEcheanceTtc', 'dateEcheance', 'nomCommercial', 'referencePaiement', 'bonAPayer', 'motifBlocage', 'commentaire', 'modeReglement', 'blocageReglement'],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'paiementsurfacture',
        Filtres: this.lastPayload,
      };
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPageAndCheckChangement);
      await this.loadParametreUtilisateur();
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
